// extracted by mini-css-extract-plugin
module.exports = {"main":"_5QHivYkvismNMs-PV0yMo","icon":"_3GQxx9VN6G4T5HGaYc07pV","titulo":"_2AbaHNAGZr2AgHqqQaja3E","subTitulo":"_1YXBsh5mKFi45QCsX26Co4","back":"_3nKjKg2pTMfSuGpIw4U4jt"};